import {
Typography,
DialogContent,
} from "@mui/material";
import BootstrapDialog from "../../helpers/BootStrapDialog";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";

const Modal = (props) => {
  const { title, select, children, setSelect } = props;

  return (
    <BootstrapDialog
      onClose={() => {
        setSelect(false);
      }}
      fullWidth={true}
      maxWidth={"md"}
      aria-labelledby="customized-dialog-title"
      open={select}
    >
      {/* <Box sx={style} className="overflow-auto"> */}
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => {
          setSelect(false);
        }}
        Typography sx={{textTransform:"uppercase"}}
      >
        {title}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div>{children}</div>
      </DialogContent>

      {/* </Box> */}
    </BootstrapDialog>
  );
};
export default Modal;
